<template>
  <div class="page-header-small">
    <div class="header-content">
      <div class="header-text">
        <h3 class="card-title">
          <slot name="title"></slot>
        </h3>
        <p class="card-description">
          <slot name="description"></slot>
        </p>
      </div>

      <div class="header-actions">
        <div class="action-buttons-top">
          <slot name="actions-top"></slot>
        </div>

        <div class="action-buttons-bottom">
          <slot name="actions-bottom"></slot>
        </div>
        <div v-if="$slots['actions-extra']" class="action-buttons-extra">
          <slot name="actions-extra"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenericPageHeader'
};
</script>

<style lang="scss" scoped>
.page-header-small {
  background: var(--bs-card-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: var(--radius-md);
  transition: all 150ms;
}

.header-content {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;
  gap: 1.5rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}

.header-text {
  flex: 1;
  height: 100%;
}

.card-title {
  font-weight: 600;
  line-height: 1.25;
  margin-bottom: 0.375rem;
}

.card-description {
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 0;
  color: var(--color-muted-foreground);
}

.header-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
}

.action-buttons-top,
.action-buttons-bottom,
.action-buttons-extra {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
}

.view-select {
  width: 350px;
  max-width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
}
</style>
